const tokenName = 'X-Auth-Token';

const getUserToken = () => {
  let token = '';

  document.cookie.split(';').forEach((i) => {
    const pair = i.split('=');
    if (pair[0].trim() === tokenName) {
      token = pair[1];
    }
  });
  return token;
};

const removeToken = () => {
  document.cookie = `${tokenName}==;Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
};

const extendTokenExpiration = () => {
  storeToken(getUserToken());
};

const storeToken = (newToken: string) => {
  const expiration = new Date();
  let cookieString = `${tokenName}=${newToken}`;

  expiration.setDate(new Date().getDate() + 30);

  // clear token cookie
  // set cookie
  removeToken();
  cookieString += `;Expires=${expiration.toUTCString()}`;
  document.cookie = cookieString;
};

export { getUserToken, removeToken, extendTokenExpiration, storeToken };
